import lightbox from 'lightbox2';

lightbox.option({
  disableScrolling: true,
  maxWidth: 800,
  maxHeight: 800,
});
